
<div class="filter-popup">
    <div class="filter-heading">
        <h2 style="color: #0D87C8">Filter Leads</h2>
    </div>
    <form [formGroup]="filterForm">
        <div class="filter-row">
          <div class="filter-column">           
            <div class="field">
              <p class="label">Country</p>              
              <mat-form-field appearance="outline" class="filter-input" [ngClass]="{'highlighted-error' :highlightCountry }">
                <input
                  matInput
                  [matAutocomplete]="countryAuto"
                  placeholder="Search for Country"
                  formControlName="country"
                  (input)="onOptionChange('country')"
                />
                <mat-autocomplete
                  #countryAuto="matAutocomplete"
                  (optionSelected)="onCountryChange($event.option.value)"   [displayWith]="displayCountry">
                  <mat-option *ngFor="let country of filteredCountries" [value]="country">
                    {{ country.countryName}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="field">
              <p class="label">State</p>            
              <mat-form-field appearance="outline" class="filter-input" [ngClass]="{'highlighted-error' :highlightState }">
                <input
                  matInput
                  [matAutocomplete]="stateAuto"
                  placeholder="Search for State"
                  formControlName="state"
                  (input)="onOptionChange('state')"
                  (focus)="onStateFocus()" 
                />
                <mat-autocomplete
                  #stateAuto="matAutocomplete"
                  (optionSelected)="onStateChange($event.option.value)" [displayWith]="displayState" >
                  <mat-option *ngFor="let state of filteredStates" [value]="state">
                    {{ state.stateName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="field">
                <p class="label">City</p>               
                <mat-form-field appearance="outline" class="filter-input">
                  <input
                    matInput
                    [matAutocomplete]="cityAuto"
                    placeholder="Search for City"
                    formControlName="city"
                    (input)="onOptionChange('city')"
                    (focus)="onCityFocus()"
                  />
                  <mat-autocomplete
                    #cityAuto="matAutocomplete"
                    (optionSelected)="onCityChange($event.option.value)" [displayWith]="displayCity">
                    <mat-option *ngFor="let city of filteredCities" [value]="city" >
                      {{ city.cityName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-column">
            <div class="field">
                <p class="label">Account Type</p>
                <mat-form-field appearance="outline" class="filter-input">
                    <mat-select formControlName="accountType" placeholder="Select">
                    <mat-option value="OEM">OEM</mat-option>
                    <mat-option value="Distributor">Distributor</mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
            <div class="field">
              <p class="label">Company Name</p>
              <mat-form-field appearance="outline" class="filter-input">
                <input matInput placeholder="Enter Company Name" formControlName="companyName">
              </mat-form-field>
            </div>
            <div class="field">
                <p class="label">Stage</p>
                <mat-form-field appearance="outline" class="filter-input">                  
                    <mat-select formControlName="leadState" placeholder="Select">
                        <mat-option value="initial_contact">Initial Contact</mat-option>
                        <mat-option value="schedule_appointment">Schedule Appointment</mat-option>
                        <mat-option value="qualified">Qualified</mat-option>
                        <mat-option value="account_created">Account Created</mat-option>
                        <mat-option value="on_hold">On Hold</mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
          </div>
        </div>
          <div class="field">
            <p class="label">Added By</p>
            <mat-form-field appearance="outline" class="filter-input">
              <input
                matInput
                [matAutocomplete]="addedByAuto"
                placeholder="Search for Staff"
                [formControl]="addedByControl"
              />
              <mat-autocomplete
                #addedByAuto="matAutocomplete"
                (optionSelected)="handleAddedByChange($event.option.value.user_name)"
                [displayWith]="displayAddedBy">
                <mat-option *ngFor="let staff of filteredStaffData" [value]="staff">
                  {{ staff.user_name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="chips?.length" class="row-container-2">
            <span class="paragraph-medium">Filters applied: </span>
            <mat-chip
              class="chip-item"
              *ngFor="let chip of chips"
              (removed)="remove(chip)"
              style="margin-bottom: 4px;"
            >
              {{ chip?.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </div>      
        <div class="footer">
            <button mat-raised-button class="filter-btn" (click)="submitFilter()">Filter</button>
            <button mat-raised-button class="clear-btn" (click)="clearFilter()">Clear</button>&nbsp;&nbsp;
            <button mat-raised-button class="clear-btn" (click)="cancelFilter()">Clear & Cancel</button>
        </div>
      </form>       
</div>